<template>
  <div>
    <h3>{{ title }}</h3>
    <b-table
      small
      hover
      outlined
      foot-clone
      :items="items"
      head-variant="light"
      :fields="fields"
    >
      <template v-slot:foot()="data"></template>
      <template v-slot:foot(net_kilograms)="data">
        <span>{{ footers.net_kilograms }}</span>
      </template>
      <template v-slot:foot(gross_kilograms)="data">
        <span>{{ footers.gross_kilograms }}</span>
      </template>
      <template v-slot:foot(quantity)="data">
        <span>{{ footers.quantity }}</span>
      </template>
      <template v-slot:cell(action)="data">
        <span>
          <a
            target="_blank"
            href="#"
            v-show="table_type == 1"
            @click.prevent="printRow(data.item, data.index)"
            class="fa fa-lg fa-print text-info"
            title="Imprimir"
          ></a
          >&nbsp;

          <a
            target="_blank"
            href="#"
            @click.prevent="deleteRow(data.item, data.index)"
            class="fa fa-lg fa-close text-danger"
            title="Eliminar"
          ></a
          >&nbsp;
        </span>
      </template>
      <template v-slot:cell(selling_format)="data">
        <span>
          {{
            sellingFormat(data.item.units_per_container, data.item.kg_per_unit)
          }}
        </span>
      </template>
      <template v-slot:cell(product_name)="data">
        <span v-if="data.item.is_devolution">
          {{ data.item.product_name }}
          <b-badge :variant="getBadge(data.item.is_devolution)">
            DEVOLUCIÓN</b-badge
          >
        </span>
        <span v-else>
          {{ data.item.product_name }}
          <b-badge variant="primary">
            {{ data.item.product_type.name }}</b-badge
          >
        </span>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "ContentTable",
  props: {
    table_type: {
      type: Number,
      default: 0
    },
    items: {
      type: [Array, Object],
      default: []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    footers: {
      type: [Object, Function],
      default: () => {
        return {
          net_kilograms: 0,
          gross_kilograms: 0,
          quantity: 0
        };
      }
    }
  },
  methods: {
    deleteRow(item, index) {
      this.$emit("delete-row", {
        table: this.table_type,
        item: item,
        index: index
      });
      // this.$store.commit('bagnoProcessModule/deleteRow', a);
    },
    sellingFormat(units, kg) {
      return units === 0 ? "no aplica" : units + "Un x " + kg + "Kg";
    },
    getBadge(condition) {
      return condition ? "warning" : "secondary";
    },
    printRow(item, index) {}
  },
  data() {
    return {
      hola: null
    };
  }
};
</script>

<style scoped></style>
